// Import controller interfaces
import {
    IPolicyController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    NewBusinessApplication,
    Peril,
    PolicySearchResult,
    PolicyTermPacket,
    PolicyTermWithStatus,
    ProducerInfo,
    ProducerAgency,
    ProducerAgent,  
    PublicPolicyViewData,  
} from '@app/models/api';
// Import enumerations.
import {
    BroadLineOfBusiness
} from '@app/enumerations';

export default class MockPolicyController implements IPolicyController {

    public constructor() {
 
    }

    public async getAllPolicyTermYears(policyId: number): Promise<number[]> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve([
                    2017,
                    2018,
                    2019,
                    2020,
                    2021,
                ]);
            }, 1000);
        });
    }

    public async getPolicyProducerInfo(policyId: number): Promise<ProducerInfo> {
        return new Promise((resolve, reject) => {
            let agent: ProducerAgent = new ProducerAgent();
            agent.email = 'insuranceAgent@test.com';
            agent.name = 'Test Agent';
            agent.agentId = 0;

            let agency: ProducerAgency = new ProducerAgency();
            agency.name = 'Test Agency';
            agency.phone = '(888) 888-8888';
            agency.agencyId = 0;

            let producerInfo = new ProducerInfo();
            producerInfo.producerAgency = agency;
            producerInfo.producerAgent = agent;
            
            setTimeout(() => {
                resolve(producerInfo);
            }, 1000);
        });
    }

    public async changePolicyProducerAgent(policyId: number, producerAgentId: number): Promise<{ policyId: number; }> {
        throw new Error("Method not implemented.");
    }

    public async changePolicyProducerAgency(policyId: number, producerAgencyId: number): Promise<{ policyId: number; }> {
        throw new Error("Method not implemented.");
    }

    public async copyPolicyToNewBusinessApplication(policyId: number): Promise<NewBusinessApplication> {
        throw new Error("Method not implemented.");
    }

    public async canPolicyBeCopiedToNewBusinessApplication(policyId: number): Promise<boolean> {
        throw new Error('Method not implemented.');
    }

    public async searchPolicies(searchQuery: string): Promise<PolicySearchResult[]> {
        return new Promise((resolve, reject) => {
            let policySearchResult1 = new PolicySearchResult();
            policySearchResult1.broadLineOfBusinessCode = BroadLineOfBusiness.PERSONAL;
            policySearchResult1.insuredAddress1 = '123 Test St.';
            policySearchResult1.insuredAddress2 = null;
            policySearchResult1.insuredCity = 'Test 1 City';
            policySearchResult1.insuredState = 'Test 1 State';
            policySearchResult1.insuredZip = '12345';
            policySearchResult1.isActive = true;
            policySearchResult1.isQuote = false;
            policySearchResult1.oldPolicyNumber = null;
            policySearchResult1.policyId = 1;
            policySearchResult1.policyName = 'NCIP-1';
            policySearchResult1.propertyAddress1 = '234 Test St.';
            policySearchResult1.propertyAddress2 = 'Ste 101';
            policySearchResult1.propertyCity = 'Testerville';
            policySearchResult1.propertyState = 'District of Test';
            policySearchResult1.propertyZip = '23456';
            policySearchResult1.recordType = 'Active';
            policySearchResult1.userFirst = 'Test 1';
            policySearchResult1.userLast = 'Testerson 1';
            policySearchResult1.insuredFirst = 'Test Insured 1';
            policySearchResult1.insuredLast = 'Testerson Insured 1';

            let policySearchResult2 = new PolicySearchResult();
            policySearchResult2.broadLineOfBusinessCode = BroadLineOfBusiness.PERSONAL;
            policySearchResult2.insuredAddress1 = '321 Test St.';
            policySearchResult2.insuredAddress2 = null;
            policySearchResult2.insuredCity = 'Test 2 City';
            policySearchResult2.insuredState = 'Test 2 State';
            policySearchResult2.insuredZip = '54321';
            policySearchResult2.isActive = false;
            policySearchResult2.isQuote = true;
            policySearchResult2.oldPolicyNumber = null;
            policySearchResult2.policyId = 2;
            policySearchResult2.policyName = 'NCIP-2';
            policySearchResult2.propertyAddress1 = '432 Test St.';
            policySearchResult2.propertyAddress2 = 'Ste 102';
            policySearchResult2.propertyCity = 'Testerville 2';
            policySearchResult2.propertyState = 'District of Test 2';
            policySearchResult2.propertyZip = '65432';
            policySearchResult2.recordType = 'Endorsement';
            policySearchResult2.userFirst = 'Test 2';
            policySearchResult2.userLast = 'Testerson 2';
            policySearchResult2.insuredFirst = 'Test Insured 2';
            policySearchResult2.insuredLast = 'Testerson Insured 2';

            setTimeout(() => {
                resolve([
                    policySearchResult1,
                    policySearchResult2,
                ]);
            }, 1000);
        });
    }

    public async getPolicyPerils(policyId: number): Promise<Peril[]> {
        throw new Error('Method not implemented.');
    }

    public async getPolicyPerilsPublic(policyId: number, zipCode: string): Promise<Peril[]> {
        throw new Error('Method not implemented.');
    }

    public async getPublicPolicyTermsWithStatus(policyId: number, zipCode: string): Promise<PolicyTermWithStatus[]> {
        throw new Error('Method not implemented.');
    }

    public async getPublicPolicyViewData(policyId: number, zipCode: string): Promise<PublicPolicyViewData> {
        throw new Error('Method not implemented.');
    }

    public async getPublicPolicyTermPacket(policyId: number, zipCode: string, termYear: number): Promise<PolicyTermPacket> {
        throw new Error('Method not implemented.');
    }

    public async getLatestPublicPolicyTermPacket(policyId: number, zipCode: string): Promise<PolicyTermPacket> {
        throw new Error('Method not implemented.');
    }
};